import styled from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';

export const AgencyListContainer = styled(FlexibleDiv)`
  gap: 15px;
  padding: 15px;
  flex-direction: column;

  .fallback-view {
    margin: auto;
  }

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px 15px;
    padding: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    gap: 30px 20px;
    padding: 0;
  }

  @media screen and (min-width: 1439px) {
    width: ${({ theme }) => theme.desktopBreakpoint};
  }
`;
